const RoTranslation = {
  main: {
    Home: "Acasă",
    AboutUs: "Despre Noi",
    ExursionsFromHurghada: "Excursii de la Hurghada",
    Hotels: "Hoteluri",
    Shopping: "Cumpărături",
    Blog: "Blog",
    ContactUs: "Contactează-ne",
    CallUs: "Sună-ne",
    Email: "Email",
    ReadMore: "Citește mai mult",
  },
  Hurghada: {
    Bookyourtriponline: "Rezervă-ți călătoria online",
    NameFamilyName: "Nume / Nume de familie",
    Email: "Email",
    Phone: "Telefon (Viber sau WhatsApp sau Telegram)",
    Date: "Data",
    NumberOfPeople: "Număr de persoane",
    Adults: "Adulți",
    Children: "Copii (5-11 ani)",
    Infant: "Sugar (0-4 ani)",
    Message: "Mesaj",
    BookNow: "Rezervă acum",
  },
  Hotel: {
    Stars: "Stele",
  },
  ContactUs: {
    Address: "Adresă",
    Email: "Email",
    Phone: "Telefon",
    Name: "Nume",
    Subject: "Subiect",
    Message: "Mesaj",
    Send: "Trimite",
  },
};
export type TranslationObjectType = typeof RoTranslation;

export default RoTranslation;
